import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const COURSES = [
  {
    id: 'bc-fundamentals',
    num: '01',
    title: '区块链核心原理精讲',
    subtitle: '从零到一理解区块链的底层逻辑与技术体系',
    level: '入门',
    levelColor: '#10B981',
    duration: '8课时',
    lessons: 12,
    students: '2,847',
    category: 'blockchain',
    categoryLabel: '区块链基础',
    coverColor: '#1E40AF',
    icon: 'ri-links-line',
    badge: '必修基础',
    badgeColor: '#10B981',
    price: '¥299',
    highlights: ['哈希函数与Merkle树的真实运作', 'PoW/PoS/PBFT共识机制深度对比', 'EVM虚拟机与智能合约执行原理', '联盟链 vs 公链 vs 私链核心差异'],
    modules: [
      { title: '模块一：区块链是什么（不是你想的那样）', lessons: ['区块链的本质：分布式账本 vs 数据库', '比特币诞生的历史背景与技术突破', '哈希函数：篡改检测的数学基石', 'Merkle树：为什么区块链无法被偷偷修改'] },
      { title: '模块二：共识——多方如何达成信任', lessons: ['PoW工作量证明：用算力换信任', 'PoS权益证明：以太坊为何要切换', 'PBFT拜占庭容错：联盟链的选择', '为什么中国RWA只用联盟链'] },
      { title: '模块三：智能合约与EVM', lessons: ['智能合约：不需要法院的自动合同', 'EVM：以太坊的通用计算引擎', 'Solidity代码结构（非技术版）', 'Gas费：为什么区块链不是免费的'] },
      { title: '模块四：联盟链实战', lessons: ['蚂蚁链/长安链/FISCO BCOS对比', '区块链信息服务备案详解', '联盟链上的供应链金融应用', '联盟链存证数据如何被法院采信'] },
    ],
  },
  {
    id: 'erc-standards',
    num: '02',
    title: 'ERC标准全体系精讲',
    subtitle: '以太坊代币标准从ERC-20到ERC-4626完整解析',
    level: '进阶',
    levelColor: '#3B82F6',
    duration: '10课时',
    lessons: 16,
    students: '1,923',
    category: 'blockchain',
    categoryLabel: '技术标准',
    coverColor: '#4F46E5',
    icon: 'ri-code-s-slash-line',
    badge: 'RWA核心',
    badgeColor: '#3B82F6',
    price: '¥399',
    highlights: ['ERC-20同质化代币完整实现', 'ERC-721/1155 NFT与多资产标准', 'ERC-1400/3643合规证券代币精讲', 'ERC-4626金库标准与碳资产收益池'],
    modules: [
      { title: '模块一：ERC标准体系概论', lessons: ['ERC是什么：以太坊的通用接口规范', 'ERC vs EIP：标准提案与实现的关系', '为什么必须用ERC（兼容性/安全性/可组合性）', 'ERC全谱系速览：22个主流标准分类'] },
      { title: '模块二：同质化代币类（FT）', lessons: ['ERC-20深度解析：transfer/approve/allowance三件套', 'ERC-777高级代币：Hook回调机制', 'ERC-1404简单合规代币：黑白名单实现', 'ERC-1400证券代币标准：KYC内置设计'] },
      { title: '模块三：非同质化代币类（NFT）', lessons: ['ERC-721完整实现与元数据标准', 'ERC-721A批量铸造的Gas优化原理', 'ERC-1155多资产标准：1合约=无数资产', 'ERC-3525半同质化代币：碳资产分级最佳选择'] },
      { title: '模块四：RWA/合规专用标准', lessons: ['ERC-3643 T-REX协议完整架构', '身份注册表（Identity Registry）与合规模块', 'ERC-4626金库标准：RWA收益池标准实现', 'ERC选型决策树：你的RWA该用哪个标准'] },
    ],
  },
  {
    id: 'rwa-fundamentals',
    num: '03',
    title: 'RWA基础体系：概念到实操',
    subtitle: '真实世界资产代币化的完整知识框架',
    level: '入门',
    levelColor: '#10B981',
    duration: '12课时',
    lessons: 18,
    students: '3,412',
    category: 'rwa',
    categoryLabel: 'RWA基础',
    coverColor: '#B91C1C',
    icon: 'ri-building-2-line',
    badge: '最热门',
    badgeColor: '#EF4444',
    price: '¥499',
    highlights: ['RWA发行标准流程全链路', 'STO与传统ABS的本质差异', '主流RWA类型（房产/国债/碳信用）深度对比', '主流平台（Ondo/Centrifuge/Blackrock）案例拆解'],
    modules: [
      { title: '模块一：RWA是什么、为什么现在', lessons: ['RWA的定义与历史演进（ABS→STO→RWA）', '传统资产代币化的价值主张：5大核心优势', 'RWA vs 虚拟货币：本质区别与监管差异', '2024-2026：RWA万亿市场的底层驱动力'] },
      { title: '模块二：RWA资产类型全图谱', lessons: ['国债类RWA：Blackrock BUIDL深度解析', '房地产RWA：RealT/Brickken架构对比', '碳信用RWA：Toucan Protocol案例', '私募信贷RWA：Centrifuge/Maple/Goldfinch对比'] },
      { title: '模块三：RWA发行完整流程', lessons: ['Step 1：底层资产选择与合规筛查', 'Step 2：SPV搭建（开曼/BVI/香港结构）', 'Step 3：真实出售与资产确权', 'Step 4：KYC/AML白名单系统建设', 'Step 5：代币铸造与二级市场上线'] },
      { title: '模块四：投资RWA的风险与机遇', lessons: ['RWA四大风险：智能合约/流动性/法律/信用', '机构投资者配置RWA的逻辑框架', '散户如何合法参与RWA（香港专业投资者路径）', '未来5年RWA市场规模预测与赛道分析'] },
    ],
  },
  {
    id: 'hk-compliance',
    num: '04',
    title: '香港RWA合规全攻略',
    subtitle: 'SFC监管框架、持牌要求、合规实操一站式解析',
    level: '专业',
    levelColor: '#F59E0B',
    duration: '14课时',
    lessons: 20,
    students: '1,567',
    category: 'compliance',
    categoryLabel: '合规监管',
    coverColor: '#92400E',
    icon: 'ri-shield-check-line',
    badge: '合规必读',
    badgeColor: '#F59E0B',
    price: '¥699',
    highlights: ['SFC八号通函逐条精读', '1/4/9类牌照申请完整流程', 'KYC/AML合规系统搭建', 'VATP持牌机构选择与合作策略'],
    modules: [
      { title: '模块一：香港监管框架总图', lessons: ['SFC/HKMA/FSTB三机构分工与协作', '2023年VASP发牌制度完整解读', '证券型代币 vs 非证券型代币的判断标准', '香港 vs 新加坡 vs 美国监管路径对比'] },
      { title: '模块二：SFC核心法规精读', lessons: ['SFC八号通函原文精读（2022版）', '证监会2024年最新RWA监管指引解析', '1类/4类/9类牌照申请条件与费用', '持牌机构合作方式（外包 vs 联名）'] },
      { title: '模块三：合规基础设施搭建', lessons: ['KYC流程设计：文件要求+审核标准', 'AML系统：制裁名单筛查+可疑交易报告', 'FATF旅行规则合规方案（Notabene/VerifyVASP）', '信息披露：招股说明书撰写要点'] },
      { title: '模块四：香港RWA发行实战', lessons: ['境内资产跨境RWA化：完整合规通道', '专业投资者认定与文件管理', 'SFC审批时间线与常见拒绝原因', '上市后持续信息披露义务管理'] },
    ],
  },
  {
    id: 'china-rwa-path',
    num: '05',
    title: '中国资产RWA化实操路径',
    subtitle: '境内资产如何合法进行跨境代币化发行',
    level: '专业',
    levelColor: '#F59E0B',
    duration: '12课时',
    lessons: 16,
    students: '2,103',
    category: 'rwa',
    categoryLabel: 'RWA实操',
    coverColor: '#7F1D1D',
    icon: 'ri-map-pin-line',
    badge: '中国专项',
    badgeColor: '#EF4444',
    price: '¥599',
    highlights: ['境内资产确权（不动产/债权/碳信用）', '证监会备案函申请流程详解', 'QFLP/CIPS跨境资金通道操作', '两链一桥架构设计实操'],
    modules: [
      { title: '模块一：境内RWA的法律边界', lessons: ['十部委通知：哪些事绝对不能做', 'CSRC、PBOC、NFRA的三方管辖划分', '境内发行vs境外发行：法律主体选择', '哪些境内资产适合RWA化（资产筛选标准）'] },
      { title: '模块二：资产确权与合法转让', lessons: ['不动产确权：产权登记+无抵押证明', '企业债权确权：应收账款登记', 'CCER/碳资产确权：Verra核证+注销证明', '真实出售：从境内资产到香港SPV的法律路径'] },
      { title: '模块三：跨境通道与资金回流', lessons: ['QFLP：合格境外有限合伙人资金入境通道', 'CIPS：人民币跨境支付系统在RWA中的应用', '外汇管制申报要求与违规风险', '香港离岸人民币与RWA结算货币选择'] },
      { title: '模块四：两链一桥架构落地', lessons: ['联盟链选型（蚂蚁链/长安链/FISCO）', '以太坊/Polygon公链代币发行设置', '数据同步：链下权利变更如何触发链上更新', '境内外双重审计要求与时间成本测算'] },
    ],
  },
  {
    id: 'carbon-rwa',
    num: '06',
    title: '碳资产RWA全流程实战',
    subtitle: 'CCER/VCS碳信用代币化从确权到发行完整操作',
    level: '进阶',
    levelColor: '#3B82F6',
    duration: '16课时',
    lessons: 22,
    students: '1,289',
    category: 'rwa',
    categoryLabel: '碳资产专项',
    coverColor: '#14532D',
    icon: 'ri-leaf-line',
    badge: '碳中和热点',
    badgeColor: '#10B981',
    price: '¥799',
    highlights: ['CCER项目开发备案全流程', 'VCS/Gold Standard国际标准申请', '碳信用ERC-1155代币化实操', '全球碳市场（欧盟ETS/中国ETS/自愿市场）深度对比'],
    modules: [
      { title: '模块一：碳市场全景图', lessons: ['全球碳市场：欧盟ETS+中国ETS+自愿减排市场', '碳信用 vs 碳配额的本质区别', 'CCER重启：2023年新政与项目机会', 'VCS/Gold Standard/CAR国际标准对比'] },
      { title: '模块二：碳资产项目开发', lessons: ['林业碳汇CCER项目开发全流程', '光伏/风电碳减排项目核查方法学', '第三方核查机构（MRV）选择标准', '碳信用价格形成机制与估值方法'] },
      { title: '模块三：碳信用代币化技术', lessons: ['ERC-1155 vs ERC-3525：碳资产选型', 'Toucan Protocol/KlimaDAO架构分析', '碳信用注销凭证链上存证', '代币化碳信用的流动性方案'] },
      { title: '模块四：碳资产RWA合规发行', lessons: ['Verra平台注销→链上铸造→二级市场全流程', '香港碳信用RWA的SFC合规要求', '企业碳抵消的链上凭证设计', '碳资产RWA的收益分配（碳价上涨+管理费）'] },
    ],
  },
  {
    id: 'defi-rwa-integration',
    num: '07',
    title: 'DeFi与RWA融合策略',
    subtitle: '如何将RWA资产接入DeFi协议创造最大资本效率',
    level: '高阶',
    levelColor: '#8B5CF6',
    duration: '10课时',
    lessons: 14,
    students: '876',
    category: 'defi',
    categoryLabel: 'DeFi融合',
    coverColor: '#4F46E5',
    icon: 'ri-water-flash-line',
    badge: '高阶拓展',
    badgeColor: '#8B5CF6',
    price: '¥599',
    highlights: ['MakerDAO RWA抵押品机制深度拆解', 'Aave RWA借贷市场架构', 'AMM流动性池：RWA代币的退出通道', 'RWA+DeFi的监管灰色地带与合规边界'],
    modules: [
      { title: '模块一：DeFi基础设施精讲', lessons: ['AMM自动做市商：数学原理与滑点控制', 'Lending协议：超额抵押借贷的经济学', '稳定币机制：DAI/USDC/USDT三种路线对比', '流动性挖矿与Real Yield的区别'] },
      { title: '模块二：RWA进入DeFi的路径', lessons: ['MakerDAO RWA金库：从决策到执行', 'Centrifuge Tinlake：应收账款进入DeFi', 'Maple Finance：机构信贷的DeFi化', 'Goldfinch：无抵押贷款的RWA模式'] },
      { title: '模块三：收益优化策略', lessons: ['RWA+收益聚合器：Yield Strategy设计', '利率套利：链上利率 vs 链下利率差', '流动性提供策略：做LP的风险收益计算', '防御性策略：RWA在熊市中的稳健优势'] },
      { title: '模块四：监管与风险管理', lessons: ['DeFi监管趋势：SEC/CFTC的执法边界', 'RWA在DeFi中的流动性风险', '智能合约安全审计要点', '极端市场下的RWA清算机制'] },
    ],
  },
  {
    id: 'international-rwa',
    num: '08',
    title: '全球RWA监管与市场机遇',
    subtitle: '美国/欧盟/新加坡/中东监管框架对比与市场进入策略',
    level: '进阶',
    levelColor: '#3B82F6',
    duration: '10课时',
    lessons: 14,
    students: '1,102',
    category: 'compliance',
    categoryLabel: '国际监管',
    coverColor: '#1E3A8A',
    icon: 'ri-earth-line',
    badge: '全球视野',
    badgeColor: '#3B82F6',
    price: '¥499',
    highlights: ['SEC Reg D/S豁免路径详解', '欧盟MiCA vs MiFID II双轨对比', 'MAS Project Guardian深度分析', '中东DIFC/ADGM监管框架新机遇'],
    modules: [
      { title: '模块一：美国RWA监管', lessons: ['豪威测试在RWA中的应用', 'Reg D 506(c)豁免：合格投资者路径', 'Reg A+豁免：小额公开发行路径', 'Reg S：向非美国投资者销售的合规安排'] },
      { title: '模块二：欧盟与英国', lessons: ['MiCA条例：稳定币与非证券型代币规则', 'MiFID II与DLT MTF：证券型RWA的欧盟路径', '英国FCA监管沙盒中的RWA项目', 'Liechtenstein TOKEN法案：最友好的RWA立法'] },
      { title: '模块三：亚太新兴市场', lessons: ['MAS Project Guardian：新加坡RWA路线图', '日本FSA：Security Token制度', '澳大利亚ASIC数字资产监管框架', '香港与新加坡：亚太两大RWA中心竞争分析'] },
      { title: '模块四：中东新兴RWA中心', lessons: ['DIFC（迪拜国际金融中心）RWA监管', 'ADGM（阿布扎比全球市场）数字资产框架', '中东家族办公室对RWA的兴趣与机遇', '伊斯兰金融（Sukuk）与RWA的交叉点'] },
    ],
  },
];

export default function TrainingCoursesBanner() {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', label: '全部课程' },
    { id: 'blockchain', label: '区块链基础' },
    { id: 'rwa', label: 'RWA实操' },
    { id: 'compliance', label: '合规监管' },
    { id: 'defi', label: 'DeFi融合' },
  ];

  const filtered = activeCategory === 'all' ? COURSES : COURSES.filter((c) => c.category === activeCategory);

  return (
    <section id="training" className="py-20 bg-gradient-to-b from-gray-900 to-[#0F0A2A]">
      <div className="max-w-[1440px] mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="text-center mb-6">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-white/10 rounded-full mb-4">
            <i className="ri-graduation-cap-line text-amber-400 text-sm"></i>
            <span className="text-amber-400 text-sm font-semibold">14 · RWA专业培训课程体系</span>
          </div>
          <h2 className="text-3xl lg:text-4xl font-black text-white mb-4">
            迎着RWA中国元年的风口<br />
            <span className="text-amber-400">系统化学习，掌握时代红利</span>
          </h2>
        </div>

        {/* Pitch */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="bg-gradient-to-r from-amber-500/20 to-orange-500/20 border border-amber-500/30 rounded-2xl p-6 text-center">
            <p className="text-amber-200 text-base leading-relaxed mb-3">
              <strong className="text-amber-400">2024年是RWA中国元年。</strong>
              Blackrock启动10亿美债RWA，中银国际香港发行数字票据，监管框架从模糊走向清晰——
              这是一场比互联网金融更深刻的资产革命。
            </p>
            <p className="text-amber-100 text-sm leading-relaxed mb-3">
              但风口期同样是迷雾期：哪些是合规机遇、哪些是监管红线、如何搭建合规架构、
              碳资产如何上链、ERC标准如何选型……
              <strong>没有系统化知识，你将在风口看热闹，而不是拿红利。</strong>
            </p>
            <p className="text-white text-sm font-semibold">
              本系列8门专业课程，由业内从业者与法律专家设计，
              从区块链基础到RWA实操合规，用最短时间武装你成为RWA时代的复合型专业人才。
            </p>
          </div>
        </div>

        {/* Stats */}
        <div className="flex flex-wrap gap-4 justify-center mb-10">
          {[
            { num: '8', label: '专业课程', icon: 'ri-play-circle-line' },
            { num: '102+', label: '课时内容', icon: 'ri-time-line' },
            { num: '13,119+', label: '已报名学员', icon: 'ri-user-3-line' },
            { num: '8大方向', label: '知识覆盖', icon: 'ri-map-2-line' },
          ].map((s) => (
            <div key={s.label} className="bg-white/10 border border-white/20 rounded-xl px-5 py-3 flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center bg-amber-400/20 rounded-lg">
                <i className={`${s.icon} text-amber-400 text-sm`}></i>
              </div>
              <div>
                <div className="font-black text-white text-base leading-none">{s.num}</div>
                <div className="text-xs text-white/60">{s.label}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Category Tabs */}
        <div className="flex flex-wrap gap-2 mb-8 justify-center">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveCategory(cat.id)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeCategory === cat.id
                  ? 'bg-amber-400 text-gray-900'
                  : 'bg-white/10 border border-white/20 text-white/70 hover:bg-white/15'
              }`}
            >
              {cat.label}
            </button>
          ))}
        </div>

        {/* Course Grid */}
        <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-4 mb-10">
          {filtered.map((course) => (
            <div
              key={course.id}
              className="bg-white/5 border border-white/15 rounded-2xl overflow-hidden hover:border-amber-400/40 transition-all group cursor-pointer"
              onClick={() => navigate(`/courses/${course.id}`)}
            >
              {/* Cover */}
              <div className="h-28 flex items-center justify-center relative overflow-hidden" style={{ background: `linear-gradient(135deg, ${course.coverColor}, ${course.coverColor}88)` }}>
                <i className={`${course.icon} text-white/30 text-6xl absolute`}></i>
                <div className="relative z-10 text-center px-4">
                  <div className="text-white/60 text-xs font-bold mb-1">COURSE {course.num}</div>
                  <div className="text-white font-black text-sm leading-tight">{course.title}</div>
                </div>
                <div className="absolute top-2 right-2">
                  <span className="text-xs px-2 py-0.5 rounded-full font-semibold text-white" style={{ background: course.badgeColor }}>{course.badge}</span>
                </div>
              </div>

              {/* Info */}
              <div className="p-4">
                <p className="text-white/60 text-xs leading-relaxed mb-3 line-clamp-2">{course.subtitle}</p>
                <div className="flex items-center gap-3 text-xs text-white/50 mb-3">
                  <span className="flex items-center gap-1"><i className="ri-time-line"></i>{course.duration}</span>
                  <span className="flex items-center gap-1"><i className="ri-play-list-line"></i>{course.lessons}节</span>
                  <span className="flex items-center gap-1"><i className="ri-user-3-line"></i>{course.students}</span>
                </div>
                <div className="flex items-center justify-between">
                  <div>
                    <span className="text-xs px-2 py-0.5 rounded-full text-white font-medium" style={{ background: course.levelColor + '33', color: course.levelColor }}>{course.level}</span>
                  </div>
                  <div className="text-amber-400 font-black text-base">{course.price}</div>
                </div>
                <button className="mt-3 w-full py-2 bg-amber-400/10 border border-amber-400/30 text-amber-400 rounded-xl text-xs font-semibold hover:bg-amber-400 hover:text-gray-900 transition-all group-hover:bg-amber-400 group-hover:text-gray-900 cursor-pointer whitespace-nowrap">
                  查看课程详情 →
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <button
            onClick={() => navigate('/courses')}
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-amber-400 text-gray-900 rounded-full font-black text-base hover:bg-amber-300 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-graduation-cap-line"></i>
            查看全部课程与学习路径
            <i className="ri-arrow-right-line"></i>
          </button>
          <p className="text-white/40 text-xs mt-3">视频课程持续更新中 · 购买后永久有效 · 支持开具发票</p>
        </div>
      </div>
    </section>
  );
}
